import { useQuery } from 'react-query';

import { FeatureFlags } from '@/types/domains/featureFlags.types';
import request from '@/utils/request';

export const useGetFeatureFlags = () => {
  const requestUrl = `${process.env.FRONT_API_URL}/features/flags`;

  const queryFn = () =>
    request(requestUrl, {
      method: 'GET',
    });

  return useQuery<FeatureFlags>({
    queryKey: ['featureFlags'],
    queryFn,
    refetchOnWindowFocus: false,
  });
};
